/**
 * Gravity forms
 */
(function($) {
  $(document).on('gform_post_render', function(){
    $('.ginput_container > textarea, .ginput_container > input').each(function() {

      var $placeholder = $("label[for='"+this.id+"']");
      $placeholder.addClass('gfield_label_placeholder');

      if ($(this).val()) {
        $placeholder.addClass('gfield_label--focus');
        $(this).addClass('focused');
      }
    });

    $('.ginput_container > textarea, .ginput_container > input').focus( function() {

      var $label = $("label[for='"+this.id+"']");

      $label.addClass('gfield_label--focus');
      $(this).addClass('focused');
    });


    $('.ginput_container > textarea, .ginput_container > input').blur( function() {

      var $label = $("label[for='"+this.id+"']");
      if(!this.value) {
          $label.removeClass('gfield_label--focus');
          $(this).removeClass('focused');
      }
    });
  });
})(jQuery);
